import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface AppThemeConfigState {
  appBackgroundColor?: string;
  headerBackgroundColor?: string;
  headerForegroundColor?: string;
  headerTitle?: string;
  headerLogoLeft?: string;
  headerLogoRight?: string | string[];
  shellForegroundColor?: string;
  sidebarBackgroundColor?: string;
  sidebarForegroundColor?: string;
}

const initialState: AppThemeConfigState = {};

export const appThemeConfigSlice = createSlice({
  name: "appThemeConfig",
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<AppThemeConfigState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setConfig } = appThemeConfigSlice.actions;
export default appThemeConfigSlice.reducer;
